import { render, staticRenderFns } from "./TrainingDetail.vue?vue&type=template&id=0857f833&"
import script from "./TrainingDetail.vue?vue&type=script&lang=js&"
export * from "./TrainingDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports